export const TOKEN_KEY = 'natureway_token';
export const GUEST_CART_KEY = 'natureway_guest_cart_id';
export const USERNAME_KEY = 'natureway_username';
export const CHECKOUT_PROMO_KEY = 'natureway_checkout_promo';

export const migrateSessionStorage = () => {
    const keys = {
        byos_token: TOKEN_KEY,
        byos_guest_cart_id: GUEST_CART_KEY,
        BYOS_UserName: USERNAME_KEY,
        ByosCompare1: 'natureway_compare_1',
        ByosCompare2: 'natureway_compare_2',
        ByosCompare3: 'natureway_compare_3',
    };
    Object.entries(keys).forEach(([oldKey, newKey]) => {
        const value = localStorage.getItem(oldKey);
        if (value !== null && localStorage.getItem(newKey) === null) {
            localStorage.setItem(newKey, value);
        }
        localStorage.removeItem(oldKey);
    });
};

migrateSessionStorage();

export const clearSession = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USERNAME_KEY);
    localStorage.removeItem(GUEST_CART_KEY);
    localStorage.removeItem(CHECKOUT_PROMO_KEY);
};

export const getSignInDestination = (location) => {
    const from = location && location.state && location.state.from;
    const query = new URLSearchParams((location && location.search) || '');
    const destination = typeof from === 'string' ? from
        : from ? `${from.pathname || ''}${from.search || ''}${from.hash || ''}`
        : query.get('returnTo');
    return destination && /^\/(?![/\\])/.test(destination)
        && !destination.startsWith('/signin') ? destination : '/';
};
